import React, { useEffect, useState } from "react";

export default function BrandCard({ nom }) {
  const [imageFound, setImageFound] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const findImage = async () => {
      const name = nom?.toLowerCase().replace(/\s+/g, "-");
      const basePath = `/assets/${name}`;
      const extensions = [".webp", ".png", ".jpg", ".jpeg"];

      for (const ext of extensions) {
        const url = `${basePath}${ext}`;

        const exists = await new Promise((resolve) => {
          const img = new Image();

          img.onload = () => resolve(true);
          img.onerror = () => resolve(false);

          img.src = url;
        });

        if (exists) {
          if (!cancelled) {
            setImageFound(url);
          }
          return;
        }
      }

      if (!cancelled) {
        setImageFound(null);
      }
    };

    findImage();

    return () => {
      cancelled = true;
    };
  }, [nom]);

  return (
    <div className="bg-white rounded shadow-sm p-4 text-center h-100">
      {imageFound ? (
        <img
          loading="lazy"
          src={imageFound}
          alt={nom ? `Logo de ${nom}` : "Logo de marque"}
          style={{ height: "50px", objectFit: "contain", marginBottom: "12px" }}
        />
      ) : (
        <div className="text-primary mb-2" style={{ fontSize: "2rem" }}>
          <i className="bi bi-car-front"></i>
        </div>
      )}

      <h6 className="fw-semibold m-0">{nom}</h6>
    </div>
  );
}